import { fromJS } from 'immutable'

export function calculateScore({
  uniqueOpens = 0,
  uniqueClicks = 0,
  mailsDelivered = 0,
  earnedMediaBuzz = 0
}) {
  const openRate = mailsDelivered > 0 ? uniqueOpens / mailsDelivered : 0
  const clickRate = mailsDelivered > 0 ? uniqueClicks / mailsDelivered : 0
  const buzzRate = mailsDelivered > 0 ? earnedMediaBuzz / mailsDelivered : 0

  return ((openRate || 0) + (3 * (clickRate || 0)) + (10 * (buzzRate || 0))) * Math.log(1 + mailsDelivered)
}

export const calculateRanking = contacts => contacts.sort((a, b) => {
  if (b.get('score') !== a.get('score')) {
    return b.get('score') - a.get('score')
  }

  if (b.get('ctor') !== a.get('ctor')) {
    return b.get('ctor') - a.get('ctor')
  }

  if (b.get('ctr') !== a.get('ctr')) {
    return b.get('ctr') - a.get('ctr')
  }

  return b.get('publicationReach') - a.get('publicationReach')
}).map(contact => contact.get('id'))

export const calculateContactPerformance = contacts => {
  const sortedByCtr = contacts
    .filter(contact => contact.get('ctr') > 0)
    .sort((a, b) => a.get('ctr') - b.get('ctr'))
  const sortedByCtor = contacts
    .filter(contact => contact.get('ctor') > 0)
    .sort((a, b) => a.get('ctor') - b.get('ctor'))

  const distinctCtrValues = new Set(sortedByCtr.map(contact => contact.get('ctr')).toArray()).size
  const distinctCtorValues = new Set(sortedByCtor.map(contact => contact.get('ctor')).toArray()).size
  const shouldAssignCtrBand = distinctCtrValues >= 10
  const shouldAssignCtorBand = distinctCtorValues >= 10
  const sortedCtrIds = sortedByCtr.map(contact => contact.get('id'))
  const sortedCtorIds = sortedByCtor.map(contact => contact.get('id'))

  // Get the sizes for band calculation
  const ctrSize = sortedCtrIds.size
  const ctorSize = sortedCtorIds.size

  // Precompute index maps for O(1) lookups instead of repeated indexOf calls
  const ctrIndexById = {}
  const ctorIndexById = {}

  sortedCtrIds.forEach((id, index) => {
    ctrIndexById[id] = index
  })

  sortedCtorIds.forEach((id, index) => {
    ctorIndexById[id] = index
  })

  const contactPerformance = contacts.reduce((acc, contact) => {
    const contactId = contact.get('id')
    const ctrIndex = ctrIndexById[contactId] || 0
    const ctorIndex = ctorIndexById[contactId] || 0

    const ctrBand = shouldAssignCtrBand
      ? 1 + (ctrSize > 0 ? Math.floor((ctrIndex / ctrSize) * 5) : 0)
      : undefined
    const ctorBand = shouldAssignCtorBand
      ? 1 + (ctorSize > 0 ? Math.floor((ctorIndex / ctorSize) * 5) : 0)
      : undefined

    acc[`${contactId}`] = {
      ctrBand,
      ctorBand
    }

    return acc
  }, {})

  return fromJS(contactPerformance)
}
